module.exports = __webpack_public_path__ + "img/congratulations.bb718628.png";